<div class="grid grid-cols-5 gap-2">
  <div class="col-span-4 flex flex-col">
    <label [tailLabel]="i" i18n="@@image_source">Image source</label>
    <input type="url" #i="input" tailInput [(ngModel)]="value" placeholder="https://...">
    <div class="pt-2">
      <input type="file" accept="image/*" (change)="onFileSelected($event)" [disabled]="uploading">
      <p class="text-xs text-gray-500" *ngIf="uploading">Uploading...</p>
    </div>
  </div>
  <div class="col-span-1 rounded border overflow-hidden bg-white">
    <img [src]="value" alt="" class="w-full h-full" *ngIf="value?.length">
  </div>
</div>
